export const { MODE, VITE_API_URL, VITE_SOCKET_URL, VITE_BUG_SNAG_API_KEY } = import.meta.env;

export const BUG_SNAG_ENABLED = Boolean(VITE_BUG_SNAG_API_KEY);

export const IS_DEV = MODE === 'development';
export const IS_PROD = MODE === 'production';
export const API_URL = VITE_API_URL || 'http://localhost:3000';
export const SOCKET_URL = VITE_SOCKET_URL || 'ws://localhost:3000';
